import { isValid, parse } from 'date-fns'

export const formatToBoolValue = (v: string) => {
    const yesValues = ['yes', 'y', 'true']
    return yesValues.includes(v.toLowerCase()) ? 'true' : 'false'
}

export const formatFromBoolValue = (v: string) => {
    return v === null ? v : v === 'true' ? 'Yes' : 'No'
}

export const parseDate = (value: string) => {
    const parsed = parse(value, 'dd.MM.yyyy', new Date().setHours(0, 0, 0, 0))
    if (!isValid(parsed)) {
        return null
    }

    return parsed
}
